import { useRef, useState } from 'react';
import { useActionData, Form } from 'react-router-dom';
import { getAuthToken } from '../util/auth.jsx'
import backend from '../util/backend.jsx';

import classes from './Files.module.css';

export var UploadComplete = null;

export function UploadFile() {
  const [selectedFile, setSelectedFile] = useState(null);
  const selectedFileRef = useRef(null);

  const data = useActionData();

  const fileSelected = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files ? event.target.files[0] : null;
    setSelectedFile(file);
  };

  const fileSubmit = async () => {
    UploadComplete = null;

    const formData = new FormData();
    formData.append('file', selectedFile);

    const token = getAuthToken();
    const response = await fetch(`https://${backend}/uploadfile`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`
      },
      body: formData,
    });

    if (!response.ok) {
      const issue = await response.text();
      console.error(`upload error: ${selectedFile.name} -- ${issue}`);
      const result = {'errors': [issue]};
      UploadComplete = result;
      return result;
    }
    setSelectedFile(null);
    selectedFileRef.current.value = '';
    UploadComplete = {'success': 'ok'};
  }

  return (
    <Form
      method="post"
      action="/files"
      encType="multipart/form-data"
      className={classes.file}
    >
      <label>File to upload:</label>
      <input type="file" name="file" ref={selectedFileRef} onChange={fileSelected} />
      <button disabled={!selectedFile} onClick={fileSubmit}>Upload</button>
      {data && data.errors && (
        <ul>
          {Object.values(data.errors).map((error) => (
            <li className={classes.error} key={error}>{error}</li>
          ))}
        </ul>
      )}
    </Form>
  );
}

export default UploadFile;
